import { useCallback } from 'react';

import type { InvestorFirmCreateDtoInput } from '../../../../../../graphql';
import {
  useInvestorFirms_AddInvestorFirmMutation,
  useInvestorFirms_AdminAddInvestorFirmMutation,
} from '../graphql/__generated__';

export function useCreateInvestorFirm(tenantId?: string) {
  const [addInvestorFirmAsCustomer, { error: errorAsCustomer }] =
    useInvestorFirms_AddInvestorFirmMutation();
  const [addInvestorFirmAsAdmin, { error: errorAsAdmin }] =
    useInvestorFirms_AdminAddInvestorFirmMutation();

  const addInvestorFirm = useCallback(
    async (input: InvestorFirmCreateDtoInput) => {
      if (tenantId) {
        return await addInvestorFirmAsAdmin({
          variables: {
            input: {
              tenantId,
              input,
            },
          },
        });
      } else {
        return await addInvestorFirmAsCustomer({
          variables: {
            input: { input },
          },
        });
      }
    },
    [tenantId, addInvestorFirmAsAdmin, addInvestorFirmAsCustomer]
  );

  return { addInvestorFirm, error: errorAsAdmin ?? errorAsCustomer };
}
